import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/washington/dominate_back.webp";
import { Link } from "gatsby";

function Richhouston() {
  return (
    <section
      className="rich_houston dominate_washington"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <h2>Ready to Dominate the Washington DC Tech Industry?</h2>
            <p>
              Let’s collaborate and build a next-gen app solution that becomes
              the trendsetter in the market.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="mt-auto">
            <div className="rich_houston_img">
              <StaticImage
                src="../../images/location_new/washington/dominate_new.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={444}
                height={470}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Richhouston;
